import { AlertTriangle } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";

const WA_URL =
  "https://wa.me/524424319100?text=Hola,%20necesito%20cotizar%20una%20reparaci%C3%B3n%20urgente%20de%20mi%20m%C3%A1quina%20CNC";

export default function AnnounceBar() {
  return (
    <div
      data-testid="announce-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-[#061226] border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-10 flex items-center justify-center gap-3 text-slate-300">
        <AlertTriangle
          size={13}
          className="text-[#00B4D8] shrink-0 hidden sm:block"
        />
        <p
          data-testid="announce-bar-text"
          className="text-[11px] sm:text-xs font-medium tracking-wide truncate"
        >
          <span className="hidden sm:inline">¿Paro de producción o colisión de CNC? </span>
          <span className="sm:hidden">¿Paro de CNC? </span>
          <span className="text-white">Diagnóstico y atención urgente en Querétaro.</span>
        </p>
        <a
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="announce-bar-cta"
          className="inline-flex items-center gap-1 shrink-0 bg-[#25D366] hover:bg-[#128C7E] text-white text-[10px] sm:text-[11px] font-bold uppercase tracking-widest px-2.5 sm:px-3 py-1 transition-colors"
          style={{ borderRadius: "2px" }}
        >
          <span className="hidden sm:inline">Chat urgente</span>
          <span className="sm:hidden">Chat</span>
          <WhatsAppIcon size={12} className="text-white" />
        </a>
      </div>
    </div>
  );
}
